export default import.meta.ROLLDOWN_FILE_URL_pOuA6Cgw0Hs2VRp4syQvcg